import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import IconPng from 'atoms/IconPng'
import { ButtonReg } from 'atoms/Buttons'
import { FormTxt, FormSelect, FormChips, FormCheck } from 'atoms/Inputs'
import { SERVER_URL } from 'fixtures/api'
import { Roles } from 'fixtures/enums'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
  CheckboxWrapper,
  PickWrapper,
  PickHover,
  ImgPicker
} from './styles'

const bgDef = require('App/assets/images/ic_user.png')
const ic_cam = require('App/assets/images/ic_cam_sm.png')
const ic_search_alt = require('App/assets/images/ic_search_alt.png')

export class NewUserModal extends PureComponent {

  checkImgSrc() {
    const { userData } = this.props
    if (userData.hasOwnProperty('displayPictureBase64')) {
      return userData.displayPictureBase64
    } else if (userData.hasOwnProperty('displayPicture') && userData.displayPicture !== null) {
      return `${SERVER_URL}${userData.displayPicture.thumbnailUrl}`
    } else {
      return bgDef
    }
  }

  isEditingMode() {
    const { userData } = this.props
    return userData.hasOwnProperty('createdAt') ? true : false
  }

  render() {
    const { theme, companiesList, groupList, deptsList, contractorsList, userData, isDisabled, fnChange } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {this.isEditingMode() ? 'Edit ' : 'Add New '} User
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <PickWrapper>
            <ImgPicker src={this.checkImgSrc()} />
            <PickHover onClick={() => document.getElementById('selectImage').click()}>
              <IconPng src={ic_cam} mb={'5px'} size={'28'} h={'25'} />
              <Label lineheight={'14px'} size={'12px'} weight={'400'} color={theme.white}>
                Add photo
              </Label>
            </PickHover>
          </PickWrapper>
          <InputRow>
            <Label lineheight={'14px'} size={'12px'}>
              Name
            </Label>
            <FormTxt
              placeholder={'Enter your name'}
              mb={'16px'}
              value={userData.displayName}
              onChangeVal={e => fnChange(e.target.value, 'displayName')}
              {...inputConfig}
            />
            <div className="px-0 mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Origin Company
              </Label>
              <FormSelect
                placeholder={'Select Company'}
                onChangeVal={e => fnChange(e.target.value, 'originCompanyId')}
                options={companiesList}
                value={userData.originCompanyId}
                valField={'id'}
                dispField={'name'}
                arrowSize={'16px'}
                {...inputConfig}
              />
            </div>
            <div className="px-0 mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Department
              </Label>
              <FormSelect
                placeholder={'Select department'}
                onChangeVal={e => fnChange(e.target.value, 'departmentId')}
                options={deptsList}
                value={userData.departmentId}
                valField={'id'}
                dispField={'nameDisplay'}
                arrowSize={'16px'}
                {...inputConfig}
              />
            </div>
            <div className="px-0 mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Allowed Companies
              </Label>
              <FormChips
                placeholder={'Select companies'}
                options={companiesList}
                dispField={'name'}
                control={userData.allowedCompanies}
                onChangeVal={e => fnChange(e, 'allowedCompanies')}
                {...inputConfig}
              />
            </div>
          </InputRow>
        </LevelRowContainer>
        <LevelRowContainer>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Email
              </Label>
              <FormTxt
                placeholder={'Enter your email'}
                mb={'16px'}
                value={userData.email}
                onChangeVal={e => fnChange(e.target.value, 'email')}
                disabled={this.isEditingMode()}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Username
              </Label>
              <div className={'row mx-0 px-0'}>
                <FormTxt
                  {...inputConfig}
                  placeholder={'Enter your username'}
                  mb={'16px'}
                  value={userData.username}
                  onChangeVal={e => fnChange(e.target.value, 'username')}
                  disabled={this.isEditingMode()}
                  width={userData.isActiveDirectory ? 'calc(100% - 34px - .5rem)' : '100%'}
                />
                {userData.isActiveDirectory &&
                  <ButtonReg
                    width={'34px'}
                    height={'34px'}
                    className={'ml-2'}
                    onClick={() => this.props.fnGetUser(userData.username)}
                    btnTxt={
                      <IconPng
                        srcIcon={ic_search_alt} mx={'0'} size={'auto'} mb={'3px'} h={'15'} showPointer={true}
                      />
                    }
                  />
                }
              </div>
            </div>

            <div className={'col-12 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Group name
              </Label>
              <FormChips
                placeholder={'Select group'}
                options={groupList}
                dispField={'name'}
                control={userData.groups}
                onChangeVal={e => fnChange(e, 'groups')}
                {...inputConfig}
              />
            </div>
            <div className={'col-12 px-0 pr-2 mt-3'}>
              <Label lineheight={'14px'} size={'12px'}>
                Role
              </Label>
              <FormSelect
                placeholder={'Select role'}
                onChangeVal={e => fnChange(e.target.value, 'userRole')}
                options={Roles}
                value={userData.userRole}
                valField={'value'}
                dispField={'label'}
                arrowSize={'16px'}
                {...inputConfig}
              />
            </div>
            {
              userData.userRole === 'CONTRACTOR' &&
              <div className={'col-12 px-0 pr-2 mt-3'}>
                <Label lineheight={'14px'} size={'12px'}>
                  Contractor
                </Label>
                <FormSelect
                  placeholder={'Select contractor'}
                  onChangeVal={e => fnChange(e.target.value, 'contractorId')}
                  options={contractorsList}
                  value={userData.contractorId}
                  valField={'id'}
                  dispField={'name'}
                  arrowSize={'16px'}
                  {...inputConfig}
                />
              </div>
            }
            <div className={'col-12 px-0 pr-2 mx-0 mt-3'}>
              <CheckboxWrapper allowEdit={!this.isEditingMode()}>
                <FormCheck
                  value={userData.isActiveDirectory}
                  allowEdit={!this.isEditingMode()}
                  fn={() => fnChange(!userData.isActiveDirectory, 'isActiveDirectory')}
                  className={'mr-2'}
                />
                <Label
                  onClick={this.isEditingMode() ? null : () => fnChange(!userData.isActiveDirectory, 'isActiveDirectory')}
                  lineheight={'12px'}
                  size={'12px'}
                  mt={'3px'}
                >
                  Active Directory user?
                </Label>
              </CheckboxWrapper>
            </div>
          </div>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg onClick={this.props.fnSwitch} disabled={isDisabled} transparent btnTxt={'Cancel'} />
          <ButtonReg onClick={this.props.fnSubmit} disabled={isDisabled} btnTxt={isDisabled ? 'Submitting...' : 'Submit'} />
        </ModalFooter>

        <input id='selectImage' hidden type="file" accept="image/*" onChange={e => fnChange(e.target.files[0], 'photo')} />
      </MainWrapper>
    )
  }
}

export default withTheme(NewUserModal)
